module.exports = __webpack_public_path__ + "img/banner2.a7e2eb91.png";